import * as CRYPTO from "crypto-js";

export const getEncryptedText = (data: any) => {
  var truncHexKey = CRYPTO.SHA256(process.env.REACT_APP_ENC_KEY || "")
    .toString()
    .substr(0, 32);

  var key = CRYPTO.enc.Utf8.parse(truncHexKey);

  var iv = CRYPTO.enc.Utf8.parse(process.env.REACT_APP_ENC_IV || "");

  var ciphertext = CRYPTO.AES.encrypt(JSON.stringify(data), key, {
    iv: iv,
    mode: CRYPTO.mode.CBC,
  });

  return ciphertext.toString();
};

export const getDecryptedData = (cipher: string) => {
  var truncHexKey = CRYPTO.SHA256(process.env.REACT_APP_ENC_KEY || "")
    .toString()
    .substr(0, 32);

  var key = CRYPTO.enc.Utf8.parse(truncHexKey);

  var iv = CRYPTO.enc.Utf8.parse(process.env.REACT_APP_ENC_IV || "");

  var decryptedData = CRYPTO.AES.decrypt(cipher, key, {
    iv: iv,
    mode: CRYPTO.mode.CBC,
  });

  return decryptedData.toString(CRYPTO.enc.Utf8);
};
